export default __webpack_public_path__ + "static/media/tankless-water-heater.d3d8b118.svg";